import React, { useEffect } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import ProjectGrid from '@/components/projects/ProjectGrid';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Projects = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainLayout>
      <div className="pt-32 pb-24 bg-[#2A2A2A]">
        <div className="container-custom">
          <motion.h1
            className="section-title text-[#D9D9D9] text-center mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t('projects.title')}
          </motion.h1>

          <motion.p
            className="max-w-3xl mx-auto text-center text-[#C0C0C0] mb-16 text-base sm:text-lg"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t('projects.subtitle')}
          </motion.p>

          <ProjectGrid />
        </div>
      </div>
    </MainLayout>
  );
};

export default Projects;
